import {Gutter} from 'antd/es/grid/row';

export const rowGutterNZM: [Gutter, Gutter] = [20, 20];
export const collageOfColors = ['#78C350', '#5BCEAE', '#46BBE0'];
export const pairsOfColour = [
  ['#FBC9C3', '#FCA2B5'],
  ['#71CECC', '#21B7B9'],
  ['#DCF5E6', '#24C065'],
  ['#FDD25E', '#FDB45E'],
  ['#E9D5FA', '#C591F8'],
  ['#EEF5FE', '#5697F8']
];

export const reportDownload =
  'https://bharatcarbon-reports-dev.s3.amazonaws.com/ca/pdfs/Carbon accounting Analysis report-Pinnacle Industries.pdf';
